import './TaxAdvisorDatev.scss';
import { useTranslation } from 'react-i18next';
import PageLayout from '../../../wrappers/PageLayout';
import { ReactComponent as GearIcon } from '../../../icons/gear.svg';
import TaxAdvisorDatevItem from './TaxAdvisorDatevItem';
import { TaxAdvisorRoutesEnum } from '../../../core/enums';
import { Link } from 'react-router-dom';
import Tabs from '../../../components/Tabs/Tabs';

export interface DatevItem {
  id: number;
  month: Date;
  local_transactions: {
    items: number;
    amount: number;
  };
  commingling: {
    items: number;
    amount: number;
  };
  shipment: {
    items: number;
    amount: number;
  };
  oss: {
    items: number;
    amount: number;
  };
  sent: boolean;
}

const TABS = [2022, 2021];

export default function TaxAdvisorDatev() {
  const { t } = useTranslation();

  const renderContent = () => (
    <>
      {DATA.map((item, i) => (
        <TaxAdvisorDatevItem
          key={item.id}
          item={item}
          className={i > 0 ? 'border-top' : ''}
        />
      ))}
    </>
  );

  return (
    <PageLayout
      data-testid='tax-advisor-datev'
      className='flex-grow-1'
      rightColumn={
        <div style={{ maxWidth: 328 }} className='ms-lg-auto pt-3 pt-lg-0'>
          <div className='Paper p-3'>
            <div className='Text--20 fw-800 pb-3 border-bottom'>
              {t('DATEV configuration')}
            </div>
            <div className='Text--gray'>{t('Konto Formats')}</div>
            <div className='pb-2 border-bottom'>
              {t('*n* digits').replace('*n*', '5')}
            </div>
            <div className='Text--gray'>{t('Gegenkonto Format')}</div>
            <div className='mb-4'>High SKR03</div>
            <Link
              className='TaxAdvisorDatev__btn Button--outline d-inline-flex align-items-center text-decoration-none'
              to={TaxAdvisorRoutesEnum.DATEVConfiguration}
            >
              <GearIcon className='me-1' /> {t('Setup')}
            </Link>
          </div>
        </div>
      }
    >
      <div className='Paper p-4'>
        <div className='Text--30 fw-900 mb-4'>{t('DATEV files')}</div>
        <Tabs tabs={TABS} renderContent={renderContent} />
      </div>
    </PageLayout>
  );
}

const DATA: DatevItem[] = [
  {
    id: 1,
    month: new Date(2022, 7, 1),
    local_transactions: {
      items: 31430,
      amount: 403000,
    },
    shipment: {
      items: 12493,
      amount: 1203093,
    },
    commingling: {
      items: 1303,
      amount: 93000,
    },
    oss: {
      items: 1303,
      amount: 93000,
    },
    sent: false,
  },
  {
    id: 2,
    month: new Date(2022, 6, 1),
    local_transactions: {
      items: 31430,
      amount: 403000,
    },
    shipment: {
      items: 12493,
      amount: 1203093,
    },
    commingling: {
      items: 1303,
      amount: 93000,
    },
    oss: {
      items: 1303,
      amount: 93000,
    },
    sent: true,
  },
  {
    id: 3,
    month: new Date(2022, 5, 1),
    local_transactions: {
      items: 31430,
      amount: 403000,
    },
    shipment: {
      items: 12493,
      amount: 1203093,
    },
    commingling: {
      items: 1303,
      amount: 93000,
    },
    oss: {
      items: 1303,
      amount: 93000,
    },
    sent: true,
  },
  {
    id: 4,
    month: new Date(2022, 4, 1),
    local_transactions: {
      items: 31430,
      amount: 403000,
    },
    shipment: {
      items: 12493,
      amount: 1203093,
    },
    commingling: {
      items: 1303,
      amount: 93000,
    },
    oss: {
      items: 1303,
      amount: 93000,
    },
    sent: true,
  },
];
